import { Sparkles, Quote, Flame, AlertCircle } from "lucide-react";
import { Section, renderRich } from "./shared";

export function ImportantFactsSection({ facts, regex }) {
  if (!facts?.length) return null;
  return (
    <Section label="Important Facts">
      <ul className="space-y-1.5">
        {facts.map((f, i) => (
          <li
            key={i}
            className="text-sm leading-relaxed border-l-2 border-black pl-3 py-0.5 relative"
          >
            <Sparkles className="w-3 h-3 text-[#3B82F6] inline-block mr-1.5 -mt-0.5" />
            {renderRich(f, regex)}
          </li>
        ))}
      </ul>
    </Section>
  );
}

export function FrequentlyEmphasizedSection({ items, regex }) {
  if (!items?.length) return null;
  return (
    <Section label="Frequently Emphasized">
      <div className="bg-[#FF3333]/5 border-l-4 border-[#FF3333] p-4">
        <Quote className="w-4 h-4 text-[#FF3333] mb-2" />
        <ul className="space-y-1.5 text-sm">
          {items.map((f, i) => (
            <li key={i} className="flex gap-2">
              <Flame className="w-3.5 h-3.5 text-[#FF3333] flex-shrink-0 mt-0.5" />
              <span>{renderRich(f, regex)}</span>
            </li>
          ))}
        </ul>
      </div>
    </Section>
  );
}

export function LowConfidenceSection({ items, regex }) {
  if (!items?.length) return null;
  return (
    <Section label="Low Confidence" dense>
      <ul className="space-y-0.5 text-xs text-zinc-500">
        {items.map((r, i) => (
          <li key={i} className="flex gap-1.5 items-start">
            <AlertCircle className="w-3 h-3 mt-0.5 flex-shrink-0" />
            <span>{renderRich(r, regex)}</span>
          </li>
        ))}
      </ul>
    </Section>
  );
}
